<template lang="">
<!--~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Start Server Requirements Page
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~-->
<div class="server-section doc-wrapper doc-inner">
    <div class="row">
        <div class="col-xl-12">
            <div class="server-wrapper">
                <h2 class="inner-title">Flutter App Version Update</h2>
                <small class="mb-30">To update your Flutter app version for old buyers, follow these steps:</small>
                <ul class="configure-list">
                    <li class="mb-10"><b>Step 1:</b> Download and Extract Update Files
                        <ol>
                            <li>Re-download the updated code from CodeCanyon.</li>
                            <li>Open the current version file on <code>Android Studio</code> or <code>VS Code</code>.</li>
                            <li>Extract the <code>[project name]-app-update-file-[version-to-version]</code> files in your root project folder or directory.</li>
                        </ol>
                    </li>
                    <li class="mb-10"><b>Step 2:</b> Ensure Flutter and Dart Packages are Updated
                        <ol>
                            <li>Ensure that Flutter and Dart packages are updated to the latest version by running the following commands in your terminal:</li>
                            <li>Run Flutter upgrade command</li>
                            <pre class="prettyprint">
                                <code>flutter upgrade --force</code>
                            </pre>
                            <li>Run Flutter pub get command</li>
                            <div class="cmd-run">
                                <code>flutter pub get</code>
                            </div>
                        </ol>
                    </li>
                    <p><b class="text--danger">Conclusion:</b> By following these steps, you can successfully update your Flutter app version for old buyers. Make sure to extract the update files in your project directory and update Flutter and Dart packages to the latest version to ensure compatibility and functionality. If you encounter any issues during the update process, refer to the documentation or seek assistance from the Flutter community.</p>
                </ul>
            </div>
        </div>
    </div>
</div>
<div class="page-change-area">
    <div class="navigation-wrapper">
        <router-link :to="{ name: 'WebsiteVersionUpdate'}" class="left"><i class="las la-angle-left me-1"></i> Website Version Update</router-link>
    </div>
</div>
<!--~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    End Server Requirements Page
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~-->
</template>
<script>
export default {
    name: 'AppVersionUpdatePage',
}
</script>